import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconContact({
    class: _cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2.5a6 6 0 0 0-6 6V13a1.5 1.5 0 0 0 1.5 1.5H8a6 6 0 0 0 0-12zm0 1a5 5 0 0 0-5 5V13a.5.5 0 0 0 .5.5H8a5 5 0 0 0 0-10zm3 4a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-2.5 2a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3z" fill={fill}/>
        </svg>
    );
}

export default IconContact;
